import { render } from "./Snapshots.vue?vue&type=template&id=1f32e610&scoped=true&ts=true"
import script from "./Snapshots.vue?vue&type=script&lang=ts"
export * from "./Snapshots.vue?vue&type=script&lang=ts"

import "./Snapshots.vue?vue&type=style&index=0&id=1f32e610&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f32e610"]])

export default __exports__